import { c as _c } from "react/compiler-runtime";
import withStyles from '@mui/styles/withStyles';
import styles from './styles';
export const DEFAULT_ILLUSTRATION = 'https://static.oc-static.com/prod/path/path_teaser_picture_default.jpeg';
const Illustration = t0 => {
  const $ = _c(10);
  const {
    classes: t1,
    className: t2,
    src: t3,
    style: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const classes = t5;
  const className = t2 === undefined ? "" : t2;
  const src = t3 === undefined ? DEFAULT_ILLUSTRATION : t3;
  let t6;
  if ($[2] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[2] = t4;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const style = t6;
  const t7 = `${classes.illustration} ${className} ${src ? "" : classes.defaultIllustration}`;
  const t8 = `url(${src || DEFAULT_ILLUSTRATION})`;
  let t9;
  if ($[4] !== style || $[5] !== t8) {
    t9 = {
      ...style,
      backgroundImage: t8
    };
    $[4] = style;
    $[5] = t8;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== t7 || $[8] !== t9) {
    t10 = <figure className={t7} style={t9} />;
    $[7] = t7;
    $[8] = t9;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  return t10;
};
export default withStyles(styles)(Illustration);